import SkeletonLoader from "~/atoms/SkeletonLoader";
import { ProgressBarGhost } from "~/components/FormBuilder/elements/ProgressBar";

const FormLoadingSkeleton = () => {
  return (
    <div className="flex min-h-full">
      <main className="grow">
        <div className="mx-auto max-w-[740px] px-6 py-10 md:px-8">
          <div className="mb-4">
            <SkeletonLoader height="24px" />
          </div>
          <ProgressBarGhost />
          <div className="mt-5 mb-6 border-b border-gray-200 pb-4">
            <SkeletonLoader height="40px" width="70%" />
          </div>
          <div>
            <SkeletonLoader height="18px" width="100px" />
          </div>
          <div className="mt-2">
            <SkeletonLoader height="36px" width="100%" />
          </div>
        </div>
      </main>

      <div className="hidden min-h-full w-80 gap-y-5 border-l border-gray-200 bg-white p-8 md:block">
        <SkeletonLoader height="24px" />
      </div>
    </div>
  );
};

export default FormLoadingSkeleton;
